import Vue from 'vue';
import dialog from './index.vue';

let instance;

const RDConstruct = Vue.extend(dialog);

const RD = function (options = {}) {
  if (!instance) {
    instance = new RDConstruct({
      data: options
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
  } else {
    Object.assign(instance.$data, options);
  }
  return instance;
};

RD.show = options => {
  const instance = RD(options);
  return instance.$show();
};

export default RD;
